import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { 
  LayoutDashboard, 
  Calendar, 
  Plus, 
  Castle,
  Users
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [unviewedCount, setUnviewedCount] = useState(0);

  useEffect(() => {
    fetchUnviewedCount();
    // Refresh every 30 seconds
    const interval = setInterval(fetchUnviewedCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchUnviewedCount = async () => {
    try {
      const response = await fetch(`${API}/reservations/unviewed-count`, { credentials: "include" });
      if (response.ok) {
        const data = await response.json();
        setUnviewedCount(data.count);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const navItems = [
    { path: "/dashboard", icon: LayoutDashboard, label: "Accueil", showBadge: true, badgePath: "/online-pending" },
    { path: "/calendar", icon: Calendar, label: "Planning" },
    { path: "/reservations/new", icon: Plus, label: "Nouveau", isMain: true },
    { path: "/structures", icon: Castle, label: "Catalogue" },
    { path: "/team", icon: Users, label: "Équipe" },
  ];

  return (
    <nav className="bottom-nav md:hidden" data-testid="bottom-nav">
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          if (item.isMain) {
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                data-testid="nav-new-reservation"
                className="relative -top-4 w-14 h-14 rounded-full bg-gradient-to-br from-festive-pink to-festive-purple text-white shadow-lg flex items-center justify-center transition-transform hover:scale-110 active:scale-95"
              >
                <Icon className="w-6 h-6" />
              </button>
            );
          }

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`relative flex flex-col items-center gap-1 py-2 px-3 rounded-xl transition-colors ${
                isActive
                  ? "text-festive-pink"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <div className="relative">
                <Icon className="w-5 h-5" />
                {item.showBadge && unviewedCount > 0 && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(item.badgePath || item.path);
                    }}
                    className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-cyan-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-pulse hover:bg-cyan-600 cursor-pointer"
                  >
                    {unviewedCount > 9 ? "9+" : unviewedCount}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
